export default function Footer() {
  const year = 2026;
  return (
    <footer className="w-full border-t border-background-200 bg-secondary-800">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#hero" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-secondary-500 text-background-50">
                <i className="ri-community-line text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-display text-lg font-bold text-background-50">吃瓜百科</span>
                <span className="text-[10px] text-secondary-200 mt-0.5 tracking-wide">GOSSIP WIKI</span>
              </span>
            </a>
            <p className="mt-4 text-sm text-secondary-200 leading-relaxed">
              吃瓜百科合集导航，把全网热门人物、事件与领域整理成清晰的知识图谱与分类索引。
              冷静追更，脉络清晰，一站式定位全站精彩内容。
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2.5 text-sm text-secondary-200">
              <li><a href="#trending" className="hover:text-background-50 transition-colors">今日热榜</a></li>
              <li><a href="#category" className="hover:text-background-50 transition-colors">分类索引</a></li>
              <li><a href="#topic" className="hover:text-background-50 transition-colors">专题目录</a></li>
              <li><a href="#map" className="hover:text-background-50 transition-colors">知识图谱</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-background-50 mb-4">站点</h4>
            <ul className="flex flex-col gap-2.5 text-sm text-secondary-200">
              <li><a href="#about" className="hover:text-background-50 transition-colors">关于我们</a></li>
              <li><a href="#faq" className="hover:text-background-50 transition-colors">常见问题</a></li>
              <li><a href="#trending" className="hover:text-background-50 transition-colors">追更入口</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-background-50 mb-4">关注我们</h4>
            <div className="flex items-center gap-2.5">
              <a href="#hero" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-700 text-secondary-100 hover:bg-secondary-600 transition-colors">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" aria-label="微信公众号" className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-700 text-secondary-100 hover:bg-secondary-600 transition-colors">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" aria-label="小红书" className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-700 text-secondary-100 hover:bg-secondary-600 transition-colors">
                <i className="ri-message-3-line"></i>
              </a>
            </div>
            <p className="mt-4 text-xs text-secondary-300 leading-relaxed">
              本站为合集导航索引站，仅作信息整理与分类参考，不生产与传播不实内容。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-secondary-700/60 pt-6">
          <p className="text-xs text-secondary-300">
            © {year} 吃瓜百科 · 合集导航与专题目录分类索引
          </p>
          <p className="text-xs text-secondary-300">
            信息整理参考站 · 理性吃瓜 · 快乐冲浪
          </p>
        </div>
      </div>
    </footer>
  );
}